//Reset data
export const RESET = "SECTEUR_LIST_RESET"

//Loading
export const SET_TOGGLE_LOADING = "SECTEUR_LIST_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "SECTEUR_LIST_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "SECTEUR_LIST_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "SECTEUR_LIST_SET_MESSAGE"
export const SET_IS_SUCCESS = "SECTEUR_LIST_SET_IS_SUCCESS"
export const SET_IS_ERROR = "SECTEUR_LIST_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "SECTEUR_LIST_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "SECTEUR_LIST_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "SECTEUR_LIST_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "SECTEUR_LIST_SET_ITEMS"
export const SET_CURRENT_ITEM = "SECTEUR_LIST_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "SECTEUR_LIST_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "SECTEUR_LIST_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "SECTEUR_LIST_SET_HIDE_MODAL"


export const SET_MODAL = "SECTEUR_LIST_SET_MODAL"
export const SET_MODAL_CONTENT = "SECTEUR_LIST_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "SECTEUR_LIST_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "SECTEUR_LIST_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "SECTEUR_LIST_SET_MODAL_TYPE"